export const headingSizes = ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl'] as const;
export type HeadingSize = (typeof headingSizes)[number];
